import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from './images_grid.module.scss';
import {classNames} from '../../../support/classnames.ts';
import {OccasionsModal} from './occasions_modal.tsx';
import {useState} from 'react';

interface OwnProps {
    occasion?: OccasionType | null;
}

export function ImagesGrid({occasion}: OwnProps) {
    const images = occasion?.pictures;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(1);

    const onImageClick = (index: number) => {
        setSelectedImage(index);
        setIsModalOpen(true);
    };
    return (
        <>
            <div className={styles.images_grid}>
                <div className={classNames(styles.images_grid__column, styles.images_grid__column_primary)}>
                    <div className={styles.image_wrapper} onClick={() => onImageClick(0)}>
                        <img src={images?.[0] ?? ''} alt={'Occasion image'} />
                    </div>
                </div>
                <div className={styles.images_grid__column}>
                    <div className={styles.image_wrapper} onClick={() => onImageClick(1)}>
                        <img src={images?.[1] ?? ''} alt={'Occasion image'} />
                    </div>
                    <div className={styles.images_grid__grid}>
                        <div className={styles.image_wrapper} onClick={() => onImageClick(2)}>
                            <img src={images?.[2] ?? ''} alt={'Occasion image'} />
                        </div>
                        <div className={styles.image_wrapper} onClick={() => onImageClick(3)}>
                            <img src={images?.[3] ?? ''} alt={'Occasion image'} />
                        </div>
                        <div className={styles.image_wrapper} onClick={() => onImageClick(4)}>
                            <img src={images?.[4] ?? ''} alt={'Occasion image'} />
                        </div>
                        <div className={styles.image_wrapper} onClick={() => onImageClick(5)}>
                            <img src={images?.[5] ?? ''} alt={'Occasion image'} />
                        </div>

                        <div className={styles.grid__count} onClick={() => onImageClick(0)}>
                            Alle {images?.length} foto&apos;s
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <OccasionsModal start={selectedImage} occasion={occasion} onCloseModal={() => setIsModalOpen(false)} />
            )}
        </>
    );
}
